import { required } from "vuelidate/lib/validators";

export default class BancosData {
  nome = "";

  banco = null;

  agencia = "";

  conta = "";

  beneficiario = "";

  tipo = "checking";

  chave_pix_carne = "";

  tipo_chave_pix_carne = "";

  pix_carne_padrao = false;

  // Campos da integração Sicoob API
  integracao_api = false;

  ambiente_api = "producao";

  client_id = "";

  numero_contrato = "";

  chave_pix = "";

  status_api = "";

  codigo_convenio = "";

  posto_beneficiario = "";

  config = {
    sicredi: {
      x_api_key: "",
      username: "",
      password: "",
      especie_documento: "DUPLICATA_MERCANTIL_INDICACAO",
    },
  };

  carteira = "";

  tipo_multa = "0";

  dias_multa = "";

  valor_multa = "";

  tipo_juros_mora = "3";

  dias_juros_mora = "";

  valor_juros_mora = "";

  dias_limite_pagamento = 30;

  mensagem_instrucao_1 = "";

  mensagem_instrucao_2 = "";

  mensagem_instrucao_3 = "";

  mensagem_instrucao_4 = "";

  mensagem_instrucao_5 = "";

  instrucoes = "";

  constructor({
    nome = "",
    banco = null,
    agencia = "",
    conta = "",
    beneficiario = "",
    tipo = "checking",
    chave_pix_carne = "",
    tipo_chave_pix_carne = "",
    pix_carne_padrao = false,
    integracao_api = false,
    ambiente_api = "producao",
    client_id = "",
    numero_contrato = "",
    chave_pix = "",
    status_api = "",
    codigo_convenio = "",
    posto_beneficiario = "",
    config = {},
    carteira = "",
    tipo_multa = "0",
    dias_multa = "",
    valor_multa = "",
    tipo_juros_mora = "3",
    dias_juros_mora = "",
    valor_juros_mora = "",
    dias_limite_pagamento = 30,
    mensagem_instrucao_1 = "",
    mensagem_instrucao_2 = "",
    mensagem_instrucao_3 = "",
    mensagem_instrucao_4 = "",
    mensagem_instrucao_5 = "",
    instrucoes = "",
  }) {
    this.nome = nome;
    this.banco = banco;
    this.agencia = agencia;
    this.conta = conta;
    this.beneficiario = beneficiario;
    this.tipo = tipo;
    this.chave_pix_carne = chave_pix_carne;
    this.tipo_chave_pix_carne = tipo_chave_pix_carne;
    this.pix_carne_padrao = pix_carne_padrao;
    this.integracao_api = integracao_api;
    this.ambiente_api = ambiente_api;
    this.client_id = client_id;
    this.numero_contrato = numero_contrato;
    this.chave_pix = chave_pix;
    this.status_api = status_api;
    this.codigo_convenio = codigo_convenio;
    this.posto_beneficiario = posto_beneficiario;
    this.config = {
      ...config,
      sicredi: {
        x_api_key: "",
        username: "",
        password: "",
        especie_documento: "DUPLICATA_MERCANTIL_INDICACAO",
        ...(config?.sicredi || {}),
      },
    };
    this.carteira = carteira;
    this.tipo_multa = tipo_multa;
    this.dias_multa = dias_multa;
    this.valor_multa = valor_multa;
    this.tipo_juros_mora = tipo_juros_mora;
    this.dias_juros_mora = dias_juros_mora;
    this.valor_juros_mora = valor_juros_mora;
    this.dias_limite_pagamento = dias_limite_pagamento;
    this.mensagem_instrucao_1 = mensagem_instrucao_1;
    this.mensagem_instrucao_2 = mensagem_instrucao_2;
    this.mensagem_instrucao_3 = mensagem_instrucao_3;
    this.mensagem_instrucao_4 = mensagem_instrucao_4;
    this.mensagem_instrucao_5 = mensagem_instrucao_5;
    this.instrucoes = instrucoes;
  }
}

export const BancosDataRequired = {
  nome: {
    required,
  },
  agencia: {
    required,
  },
  conta: {
    required,
  },
  beneficiario: {
    required,
  },
};
